// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectInstrumentPricesMessage } from "../../../../Utils/DirectMessages/DirectInstrumentPricesMessage.js"
import { DateTimeUtils } from "../../../../Utils/Time/DateTimeUtils.js"
export let InstrumentPricesMessageProcessor = function (parentDecoder)
{
    MessageProcessorBase.call(this)
    this.decoder = parentDecoder
}

InstrumentPricesMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

InstrumentPricesMessageProcessor.prototype.decode = function (fieldSet)
{
    let msg = new DirectInstrumentPricesMessage()
    let fArr = fieldSet.fieldSet
    let len = fieldSet.Count()
    for (let i = 0; i < len; i++)
    {
        this.processField(msg, fArr[i])
    }
    return [msg]
}

InstrumentPricesMessageProcessor.prototype.processField = function (msg, field)
{
    let ff = FieldsFactory
    let decoder = this.decoder

    if (field.FieldId === 0)
    {
        return
    }

    //if (field.FieldId === ff.FIELD_INSTRUMENT_ID)
    //{
    //    let tickId = field.Value
    //    let symDecodeMap = decoder.InstrumentDecodeMap
    //    msg.Symbol = symDecodeMap[tickId] || ''
    //} else
    if (field.FieldId === ff.FIELD_ROUTE_ID)
    {
        msg.Route = field.Value;//decoder.GetRouteById(field.Value)
    }
    else if (field.FieldId === ff.FIELD_INDICATIVE_AUCTION_PRICE)
    {
        msg.IndicativeAuctionPrice = field.Value
    }
    else if (field.FieldId === ff.FIELD_INDICATIVE_AUCTION_VOLUME)
    {
        msg.IndicativeAuctionVolume = field.Value
    }
    else if (field.FieldId === ff.FIELD_DATE)
    {
        msg.cTime = field.Value
    }
    else if (field.FieldId === ff.FIELD_LAST_TRADED_TIME)
    {
        msg.LastTradedTime = new Date(field.Value + DateTimeUtils.TIME_UTC_OFFSET)
    }
    else if (field.FieldId === ff.FIELD_AVG_TRADED_PRICE)
    {
        msg.AvgTradedPrice = field.Value
    }
    else if (field.FieldId === ff.FIELD_TOTAL_BUY_QTY)
    {
        msg.TotalBuyQuantity = field.Value
    }
    else if (field.FieldId === ff.FIELD_TOTAL_SELL_QTY)
    {
        msg.TotalSellQuantity = field.Value
    }
    else if (field.FieldId === ff.FIELD_AUCTION_NUMBER)
    {
        msg.AuctionNumber = field.Value
    }
    else if (field.FieldId === ff.FIELD_AUCTION_STATUS)
    {
        msg.AuctionStatus = field.Value
    }
    else if (field.FieldId === ff.FIELD_INITIATOR_TYPE)
    {
        msg.InitiatorType = field.Value
    }
    else if (field.FieldId === ff.FIELD_INITIATOR_PRICE)
    {
        msg.InitiatorPrice = field.Value
    }
    else if (field.FieldId === ff.FIELD_INITIATOR_QTY)
    {
        msg.InitiatorQuantity = field.Value
    }
    else if (field.FieldId === ff.FIELD_HI_OPEN_INTEREST)
    {
        msg.HighOpenInterest = field.Value
    }
    else if (field.FieldId === ff.FIELD_LOW_OPEN_INTEREST)
    {
        msg.LowOpenInterest = field.Value
    }
    else if (field.FieldId === ff.FIELD_TRADABLE_INSTRUMENT_ID)
    {
        msg.InstrumentTradableID = field.Value
    }
    else if (field.FieldId === ff.FIELD_TRADED_VALUE)
    {
        msg.TradedValue = field.Value
    }
    else if (field.FieldId === ff.FIELD_OFF_EXCHANGE_VOLUME)
    {
        msg.OffExchangeVolume = field.Value
    }
    else if (field.FieldId === ff.FIELD_OFF_EXCHANGE_VALUE)
    {
        msg.OffExchangeValue = field.Value
    }
    else if (field.FieldId === ff.FIELD_AUCTION_END_TIME)
    {
        msg.AuctionEndTime = field.Value
    }
    else if (field.FieldId === ff.FIELD_REMAINING_QTY)
    {
        msg.RemainingQty = field.Value
    }
    else if (field.FieldId === ff.FIELD_REMAINING_QTY_SIDE)
    {
        msg.RemainingQtySide = field.Value
    }
    else if (field.FieldId === ff.FIELD_PRICE_LOW_LIMIT)
    {
        msg.LPPLow = field.Value
    }
    else if (field.FieldId === ff.FIELD_PRICE_HI_LIMIT)
    {
        msg.LPPHigh = field.Value
    }
    else if (field.FieldId === ff.FIELD_FUNDING_RATE_VALUE)
    {
        msg.FundingRateValue = field.Value
    }
    else if (field.FieldId === ff.FIELD_MARK_PRICE)
    {
        msg.MarkPrice = field.Value
    }
    else if (field.FieldId === ff.FIELD_NEXT_FUNDING_TIME)
    {
        msg.NextFundingTimeUTC = new Date(field.Value)
    }
}
